<template>
  <md-card>
    <md-card-header class="md-card-header-icon">
      <!-- <div class="card-icon">
        <md-icon>design_services</md-icon>
      </div> -->
      <h4 class="title" style="font-weight:bold; text-align:center;">
        Sparepart
      </h4>
    </md-card-header>
    <md-card-content>
      <!-- <h4 class="title">
        Sparepart
      </h4> -->
    <md-divider></md-divider>
      <autoextra :collection="part" v-slot="{item,last,index}" v-if="part.length != 0">
        <div class="columns"  v-if="!last" :class="{last: last}">
        <label class="label">{{last ? 'New ' : ''}}Part {{!last ? index + 1 : ''}}</label>
          <div class="md-layout md-gutter" >
            <input v-model="item.id" :readonly="true" type="hidden"/>

            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Part Name</label>
                <md-input  v-model="item.name" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Part Code</label>
                <md-input  v-model="item.code" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Qty</label>
                <md-input  v-model="item.pkb_spare_part_qty" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Price</label>
                <md-input  v-model="item.price" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Discount(%)</label>
                <md-input v-model="item.pkb_spare_part_discount" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Total</label>
                <md-input  v-model="item.total" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Remarks</label>
                <md-input v-model="item.pkb_spare_part_remark"  :readonly="true"/>
              </md-field>
            </div>
          </div>            
        </div>
      </autoextra>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
          <md-field>
            <label for="total">Total</label>
            <md-input  v-model="total" name="total" id="total" :readonly="true" />
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';

export default {
  name: "service-part-card",

 
  props: ['sparepart'],
  components: { Autoextra },

  mixins: [formMixin],

  data () {
    return {
      part: [],
      options_part_list: null,
      service: [],
      options_service_list: null,
      total : 0,
    }
  },
  created() {
    this.onOpen();
  },
   
  methods:{
    async onOpen(){
      console.log(this.sparepart)
      //loop data sparepart
      this.sparepart.forEach((value, index) => {

        //set data spare part dari data sparepart
        this.$set(this.part, index, {
          id : value.id,
          name: '('+value.spare_part_master_code+') '+value.spare_part_master_name,
          pkb_spare_part_master_id : value.pkb_spare_part_master_id,
          code : value.spare_part_master_code,
          price : value.spare_part_master_unit_price,
          pkb_spare_part_qty : value.pkb_spare_part_qty,
          pkb_spare_part_discount : value.pkb_spare_part_discount,
          total : (value.spare_part_master_unit_price * value.pkb_spare_part_qty) - ((value.spare_part_master_unit_price * value.pkb_spare_part_qty) * value.pkb_spare_part_discount/100),
          pkb_spare_part_remark : value.pkb_spare_part_remark
        });
      });
          this.total =  this.part.reduce( function(cnt,o){ return cnt + o.total; }, 0)
        
    },
      
    async getDataParent(data) {
      console.log("ajajajaj")
      console.log(data)
      this.sparepart.forEach((value, index) => {
        this.$set(this.part, index, {
          id : value.id,
          name: '('+value.spare_part_master_code+') '+value.spare_part_master_name,
          pkb_spare_part_master_id : value.pkb_spare_part_master_id,
          code : value.spare_part_master_code,
          price : value.spare_part_master_unit_price,
          pkb_spare_part_qty : value.pkb_spare_part_qty,
          pkb_spare_part_discount : value.pkb_spare_part_discount,
          total : (value.spare_part_master_unit_price * value.pkb_spare_part_qty) - ((value.spare_part_master_unit_price * value.pkb_spare_part_qty) * value.pkb_spare_part_discount/100),
          pkb_spare_part_remark : value.pkb_spare_part_remark
        });
      });
        
      data.service.forEach((value, index) => {
        this.$set(this.service, index, {
          id : value.id,
          name: '('+value.service_master_code+') '+value.service_master_name,
          pkb_service_master_id : value.pkb_service_master_id,
          code : value.service_master_code,
          lts : value.service_master_lts+' hours',
          price : value.service_category_standard_cost,
          total : value.service_category_standard_cost *value.service_master_lts,
          pkb_service_remark : value.pkb_service_remark
        });
      });
        
      var totalService = 0
      var totalPart = 0
      totalService =  this.service.reduce( function(cnt,o){ return cnt + o.total; }, 0)
      totalPart =  this.part.reduce( function(cnt,o){ return cnt + o.total; }, 0)
      console.log(totalService)
      console.log(totalPart)
      this.total = totalService + totalPart
    },
    
    //fungsi yang di panggil dari parent untuk mendapatkan nilai total
    getData() {
      this.$emit('data', this.total)
    },
  },
    
  mounted() {
    console.log('Component mounted.')
  }
};
</script>

<style>
.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.md-card{
  box-shadow: 0 6px 10px 2px rgb(0 0 0 / 10%), 0 6px 10px 5px rgb(0 0 0 / 7%);
}
</style>
